import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 充值记录类型定义
 */
export interface RechargeRecord {
    id: string;                    // 记录ID
    amount: number;                // 充值金额（美元）
    dcoinAmount: number;           // 获得的DCOIN数量
    status: 'successful' | 'failed' | 'pending';  // 状态
    type: 'purchase' | 'daily_reward' | 'refund'; // 类型
    timestamp: string;             // 时间戳 (ISO 8601)
    transactionId?: string;        // 交易ID
    currency?: string;             // 货币类型
}

export interface RechargeHistoryResponse {
    success: boolean;
    data: {
        records: RechargeRecord[];
    };
    message?: string;
}

/**
 * 获取用户充值记录
 * @param {string} token 用户的 JWT Token
 * @param {string} uid 用户ID (可选，后端可能从token解析)
 * @returns {Promise<RechargeHistoryResponse>} 返回充值记录
 */
export const getRechargeHistory = async (token: string, uid?: string): Promise<RechargeHistoryResponse> => {
    const apiBaseUrl = getApiBaseUrl();
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    };

    try {
        // 使用 GET 请求获取历史记录
        const response = await axios.get(`${apiBaseUrl}/api/user/recharge-history`, {
            headers,
            params: { UID: uid }
        });

        // 处理响应数据
        if (response.data) {
            // 适配不同的响应格式
            const records = response.data.records || response.data.data?.records || response.data || [];

            // 确保是数组
            const recordsArray = Array.isArray(records) ? records : [];

            return {
                success: true,
                data: {
                    records: recordsArray.map((record: any) => ({
                        id: record.id || record._id || String(Date.now()),
                        amount: parseFloat(record.amount) || 0,
                        dcoinAmount: parseFloat(record.dcoin) || parseFloat(record.dcoinAmount) || 0,
                        status: record.status || 'successful',
                        type: record.type || 'purchase',
                        timestamp: record.timestamp || record.created_at || new Date().toISOString(),
                        transactionId: record.transactionId || record.transaction_id,
                        currency: record.currency || 'usd'
                    }))
                }
            };
        }

        return {
            success: false,
            data: { records: [] },
            message: response.data?.message || '获取充值记录失败'
        };
    } catch (error: any) {
        console.error('获取充值记录失败:', error);

        if (error?.response?.data?.message) {
            return {
                success: false,
                data: { records: [] },
                message: error.response.data.message
            };
        }

        return {
            success: false,
            data: { records: [] },
            message: '获取充值记录失败，请检查网络连接'
        };
    }
};
